import { StartType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if the plan allows future start date, false otherwise.
 */

export const allowsFutureStartDateV3 = plan => {
  var _plan$pricingVariants, _pricingVariant$billi;
  const pricingVariant = (_plan$pricingVariants = plan.pricingVariants) == null ? void 0 : _plan$pricingVariants[0];
  if (!pricingVariant) {
    return false;
  }
  const startType = (_pricingVariant$billi = pricingVariant.billingTerms) == null ? void 0 : _pricingVariant$billi.startType;
  if (startType === StartType.CUSTOM) {
    return true;
  }
  return false;
};
//# sourceMappingURL=allows-future-start-date-v3.js.map